"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomecareHomebase = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class HomecareHomebase {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        // eslint-disable-next-line no-param-reassign
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const patientInfo = this.gettingPatientDetails(pastedData);
            const insurance = this.getInsurance(pastedData);
            const contactDetails = this.getContactDetails(pastedData);
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), contactDetails);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        const name = (0, helper_1.substrInBetweenNew)(sessionFirst, "Patient:", "\n");
        const Dob = (0, helper_1.substrInBetweenNew)(sessionFirst, "DOB", "Race");
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(name)), this.patientPhoneNumberWithAddress(sessionFirst)), { dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird) {
        var _a;
        let insurance = (0, helper_1.substrInBetweenNew)(sessionThird, "Is patient in an HMO (HHCAHPS)?", "Medicare No.");
        insurance = ((_a = insurance.split("PRIMARY").pop()) === null || _a === void 0 ? void 0 : _a.trim()) || "";
        if (insurance.endsWith("N") || insurance.endsWith("Y")) {
            insurance = insurance.substr(0, insurance.length - 1).trim();
        }
        return {
            insurance,
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getContactDetails(contactDetails) {
        const caregiverRaw = (0, helper_1.substrInBetweenNew)(contactDetails, "Patient Contacts\n", "Coordination Notes");
        const physiciansRaw = (0, helper_1.substrInBetweenInclusive)(contactDetails, "Physician Info\n", "Secondary Physician Perform");
        const primaryPhy = {
            info: {
                physician: this.getPhysician(physiciansRaw),
                pharmacy: [],
                careGiver: this.getCaregiver(caregiverRaw),
            },
        };
        //@Return
        return primaryPhy;
    }
    getPhysician(data) {
        var _a;
        const physicians = [];
        let physicianNameRaw = (0, helper_1.substrInBetweenNew)(data, "Date Last Seen", "Address");
        physicianNameRaw = physicianNameRaw.substr(0, (_a = /\d{10}/.exec(physicianNameRaw)) === null || _a === void 0 ? void 0 : _a.index);
        const physicianNameParts = physicianNameRaw.split(",");
        const name = `${physicianNameParts[1]} ${physicianNameParts[0]}`;
        let numbersRaw = (0, helper_1.substrInBetweenNew)(data, "Phone Fax Pager\n", "Secondary");
        numbersRaw = numbersRaw.substr(0, 14);
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(numbersRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            physicians.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return physicians;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacies = [];
        const name = (0, helper_1.substrInBetweenNew)(data, "Pharmacy:", "\n");
        const phoneNoRaw = (0, helper_1.substrInBetweenNew)(data, "Work Phone:", "\n");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneNoRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            pharmacies.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return pharmacies;
    }
    getCaregiver(data) {
        const names = data.match(/\n([A-Z]+ )+[A-Z]+\n/g) || [];
        const caregivers = [];
        for (let i = 0; i < names.length; i++) {
            const dataBetweenNames = (0, helper_1.substrInBetweenInclusive)(data, names[i], names[i + 1] || data.slice(-10));
            const firstNumberFound = (dataBetweenNames.match(/\(\d\d\d\) \d\d\d-\d\d\d\d/g) || [])
                .map(no => {
                return (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(no)
                    .replace(/\s/, "")
                    .replace(/[\s-()]/g, ""));
            })
                .pop();
            caregivers.push({
                name: (0, helper_1.trim)(names[i]),
                phoneNo: firstNumberFound,
            });
        }
        return caregivers
            .filter(x => x.name && x.phoneNo)
            .map(x => (Object.assign(Object.assign({}, x), { countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE })))
            .map((x, index) => (Object.assign(Object.assign({}, x), { sortOrder: index + 1 })));
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        const currentServiceLocation = (0, helper_1.substrInBetweenNew)(firstSession, "Current Service Location:", "Travel Directions");
        info.phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)((0, helper_1.phoneNumbers)(currentServiceLocation)[0].replace(/[\s-()]/g, "")));
        const addressString = (0, helper_1.substrInBetweenNew)(currentServiceLocation, "State Zip County", "Phone MSA #");
        info.address.placeName = (0, helper_1.trim)(addressString);
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const breakName = sessionFirst.split(",");
        name.firstName = breakName[1];
        name.lastName = breakName[0];
        return name;
    }
}
exports.HomecareHomebase = HomecareHomebase;
